import slidesLVLP from './slides_LVLP';
import { featuresLVLP } from './features_LVLP';
import { ProjectType } from '../../Constants';
import { textLVLP } from './text_LVLP';

export const LVLPdata = {
    fr: {
        id: 3,
        name: 'LeVIVO LaPrairie',
        content: textLVLP.fr,
        yearBuilt: 2019,
        address: "155 Rue Saint-Laurent, La Prairie, QC J5R 1H1",
        city: "La Prairie",
        brand: "levivo",
        projectPage: "la-prairie",
        website: "https://levivo.ca/en/rentals-condos/levivo-la-prairie/",
        category: ProjectType.Residential,
        images: slidesLVLP,
        features: featuresLVLP.fr
    },
    en: {
        id: 3,
        name: 'LeVIVO LaPrairie',
        content: textLVLP.en,
        yearBuilt: 2019,
        address: "155 Rue Saint-Laurent, La Prairie, QC J5R 1H1",
        city: "La Prairie",
        brand: "levivo",
        projectPage: "la-prairie",
        website: "https://levivo.ca/en/rentals-condos/levivo-la-prairie/",
        category: ProjectType.Residential,
        images: slidesLVLP,
        features: featuresLVLP.en
    }
}